import { AtashsooziOmumiApiPaths } from 'Feature/Atashsoozi/Constant/AtashsooziOmumiApiPaths';
import { AggregatorApiPaths } from 'Feature/Common/Common/Constant/ApiPaths/AggregatorApiPaths';
import { BasicInfoApiPaths } from 'Feature/Common/Common/Constant/ApiPaths/BasicInfoApiPaths';
import { SoftwareManagementApiPaths } from 'Feature/Common/Common/Constant/ApiPaths/SoftwareManagementApiPaths';
import { KhodroApiPaths } from 'Feature/Khodro/ShakhsSales/ApiPaths/KhodroApiPaths';
import { MosaferatiApiPaths } from 'Feature/Mosaferati/Common/Constant/MosaferatiApiPaths';
import { OrdersApiPaths } from 'Feature/Orders/Common/Constant/OrdersApiPaths';
import { IApiPathManagerConfig } from 'Shared/ApiPaths/IApiPathManagerConfig';

const apiPathConfigs: IApiPathManagerConfig = {
  Khodro: KhodroApiPaths,
  BasicInfo: BasicInfoApiPaths,
  Aggregator: AggregatorApiPaths,
  Orders: OrdersApiPaths,
  SoftwareManagement: SoftwareManagementApiPaths,
  AtashsooziOmumi: AtashsooziOmumiApiPaths,
  Mosaferati: MosaferatiApiPaths,
  MasooliatMadani: {},
};

export default apiPathConfigs;
